import profileImage from "../../photos/Alisa_main_photo.png";
import cv from "./../../files/CV_Alisa Moldavanova_06_2025.pdf";

export const About = () => (
	<section className="container about">
		<div className="about__content">
			<div className="about__pictute">
				<img
					src={profileImage}
					alt="Alosa_Moldavanova_photo"
					className="about__picture-style"
				/>

				<div className="about__button">
					<a
						className="about__button-cv"
						href={cv}
						target="_blank"
						download
						rel="noopener noreferrer"
					>
						CV
					</a>
				</div>
			</div>

			<div className="about__text">
				<p className="about__text-style">
					Dr. Alisa Moldavanova is an accomplished scholar and
					educator dedicated to the study of organizational
					sustainability and civil society. Her research investigates
					organizational sustainability in the context of public
					service organizations, the role of inter-organizational
					networks and other forms of social connectedness in enabling
					sustainable organizations, as well as how nonprofits and
					other public service organizations foster sustainable
					development in their local communities. She is also
					conducting research on the role of civil society and
					nonprofit sector organizations in advancing democracy.
					<br />
					<br />
					Alisa Moldavanova is the author of two books, including the
					<i>
						Overlooked Pillar: Making a Case for Cultural
						Sustainability{" "}
					</i>
					(2024, SUNY Press), and the 2018 co-edited volume,{" "}
					<i>
						The Nonprofit Sector in Eastern Europe, Russia, and
						Central Asia: Civil Society Advances and Challenges,
					</i>
					an inaugural book in the nonprofit research series by Brill
					Publishers. Her work has also been published in the
					<i>
						Journal of Urban Affairs, The American Review of Public
						Administration, Public Management Review, Administration
						and Society, Public Administration and Development,
						Journal of Public Affairs Education, International
						Journal of Public Administration, and International
						Journal of Sustainability Policy and Practice.
					</i>
					<br />
					<br />
					In 2018, she co-curated a special issue on social
					institutions and sustainability in <i>Critical Sociology</i>
					. In 2023, she co-curated a special issue on civil society,
					nonprofit service providers, and democratization in{" "}
					<i>Public Administration and Development​</i>​.
					<br />
					<br />
					Dr. Moldavanova has received numerous awards for her
					teaching, scholarship, and service including the Wilder
					School Award for Exemplary Scholarship in Social Equity and
					Public Policy, Paul A. Volcker Endowment for Public Service
					Research Award (American Political Science Association), the
					University President's Award for Excellence in Teaching
					(Wayne State University) and, most recently, the 2025
					Service Award from the American Society for Public
					Administration’s Section on Public Administration Research
					and 2024 Visionary Award from the Women's Network of
					Delaware of the American Council on Education. She is
					actively involved in leadership roles in professional
					organizations such as ARNOVA, NASPAA, and ASPA.
					<br />
					<br />
					Prior to embarking on her academic career, she served in
					leadership positions in international development
					organizations, and in public and nonprofit sector
					organizations in Ukraine, focusing on international
					exchange, foreign policy, youth development, and cultural
					management. She is a 2009 Edmund S. Muskie Graduate
					Fellowship alumna (IREX, U.S. Department of State).
				</p>
			</div>
		</div>
	</section>
);
